import {  CircularProgress, styled } from "@mui/material";
import { useEffect } from "react";

type LoadingScreenProps = {
  children?: any;
  loading: boolean;
  showCircularLoader?: boolean;
  loaderColor?: string;
};

const LoadingScreen = ({ children, loading, showCircularLoader, loaderColor }: LoadingScreenProps) => {
  useEffect(() => {
    if (loading) {
      document.getElementsByTagName("body")[0]?.classList.add("loading-progress");
    } else {
      document.getElementsByTagName("body")[0]?.classList.remove("loading-progress");
    }
  }, [loading]);

  return (
    <>
      {loading && (
        <LoadingLayout>
          {showCircularLoader && <CircularProgress sx={loaderColor ? { color: loaderColor } : undefined} />}
        </LoadingLayout>
      )}
      {children}
    </>
  );
};

const LoadingLayout = styled("div")`
  z-index: 10000;
  top: 0;
  left: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(0 0 0 / 70%);
`;

export default LoadingScreen;
